import { CommonModule } from "@angular/common";
import { Component, ElementRef, EventEmitter, HostListener, Output } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ACCUEIL, MON_PROFIL, NOS_OFFRES, NOUS_CONTACTER } from "@shared/constants/route.constants";
import { LogoutComponent } from "@shared/layout/logout/logout.component";
import { isNavigationButtonVisible } from "@shared/utils/brand-utils";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-header-mobile",
  standalone: true,
  templateUrl: "./header-mobile.component.html",
  imports: [CommonModule, ButtonModule, RouterLink, LogoutComponent, TranslateModule],
})
export class HeaderMobileComponent {
  isMenuOpen = false;

  ACCUEIL = ACCUEIL;
  MON_PROFIL = MON_PROFIL;
  NOS_OFFRES = NOS_OFFRES;
  NOUS_CONTACTER = NOUS_CONTACTER;

  @Output() menuOpenEmitter = new EventEmitter<boolean>();

  constructor(
    public router: Router,
    private eRef: ElementRef
  ) {}

  isButtonVisible(buttonType: any): boolean {
    return isNavigationButtonVisible(buttonType);
  }

  emitMenuOpen(open: boolean) {
    this.menuOpenEmitter.emit(open);
  }

  @HostListener("document:click", ["$event"])
  clickout(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isMenuOpen = false;
      this.emitMenuOpen(this.isMenuOpen);
    }
  }

  menuLogoutOpen(action: boolean) {
    this.emitMenuOpen(action);
  }
}
